import * as React from 'react';
import { lazyInject } from '../../../services/inversify';
import { DataService } from '../../../services/data_service';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { IDs } from '../../../helpers/IDs';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { sortDataRfg } from '../../../main/functions/sortKomplexDataRows';
import * as config from '../../../wips.config.js';

interface CustomDatensatzRfgProps extends React.ClassAttributes<any> {
    data: any;
    entity: string;
    onChange?: () => void;
}

interface CustomDatensatzRfgState {
    rfgChecked: boolean;
    showSpinner: boolean;
}

export class CustomDatensatzRfg extends React.Component<CustomDatensatzRfgProps, CustomDatensatzRfgState> {

    constructor(props: any) {
        super(props);
        this.state = {
            rfgChecked: false,
            showSpinner: false
        };
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.updateRfgChecked();
    }

    updateRfgChecked() {
        const fnd = this.props.data[IDs.ENT_CUSTOM_DATENSATZ_REIHENFOLGE].find((r: any) => r.elementKey === getElementKey(this.props.entity));
        const rfgChecked = fnd && fnd.activated === 1 ? true : false;
        if (this.state.rfgChecked !== rfgChecked) {
            this.setState({ rfgChecked });
        }
    }

    render() {
        // const enableRfg = config.devFeaturesMap && config.devFeaturesMap.N133_DATENSATZ_REIHENFOLGE ? true : false;
        const enableRfg = true;
        if (enableRfg && hasEntityRfgField(this.props.entity)) {
            return <label
                title='Datensätze nach Reihenfolge sortieren'
                onClick={(event: any) => {
                    event.stopPropagation();
                }}
            >
                <div style={{ fontSize: 14, fontWeight: 'normal', display: 'flex', alignItems: 'center' }}>
                    <input
                        type={'checkbox'}
                        checked={this.state.rfgChecked}
                        onChange={(event: any) => {
                            const rfgChecked = event.target.checked;
                            if (this.state.rfgChecked !== rfgChecked) {
                                this.setState({ rfgChecked }, () => this.setCustomRfg(rfgChecked));
                            }
                        }}
                    />
                    <div>{String.fromCharCode(8645)}</div>
                    {this.state.showSpinner && <WSpinner />}
                </div>
            </label>;
        }
        return null;
    }

    setCustomRfg(rfgChecked: boolean) {
        this.setState({ showSpinner: true }, () => {
            const elementKey = getElementKey(this.props.entity);
            const fnd = this.props.data[IDs.ENT_CUSTOM_DATENSATZ_REIHENFOLGE].find((r: any) => r.elementKey === elementKey);
            const saveData = {
                tid: fnd ? fnd.tid : 0,
                elementKey,
                activated: rfgChecked ? 1 : 2
            };
            this.dataService.saveData(IDs.ENT_CUSTOM_DATENSATZ_REIHENFOLGE, saveData, null, null, (suc: boolean, saveTid: number) => {
                if (suc) {
                    this.setState({ showSpinner: true }, () =>
                        this.triggerService.fire('reload', IDs.ENT_CUSTOM_DATENSATZ_REIHENFOLGE, () => {
                            this.setState({ showSpinner: false });
                            if (typeof this.props.onChange === 'function') {
                                this.props.onChange();
                            }
                        }));
                }
                this.setState({ showSpinner: false });
            }, IDs.MOD_ETOOL);
        });
    }
}

export function getElementKey(entity: string) {
    // Dazu noch Jahr und StandortTid?
    return `${entity}`;
}

export function hasEntityRfgField(entity: string): boolean {
    const struct_tool = new StructureTool(IDs.MOD_ETOOL);
    const struc = struct_tool.getStructure(IDs.MOD_ETOOL, entity);
    if (struc && Array.isArray(struc.ATTS)) {
        const fnd = struc.ATTS.find((a: any) => a.KEY === 'rfg');
        return !!fnd;
    }
    return false;
}

export function hasEntityActivatedRfg(entity: string, globalData: any): boolean {
    if (globalData && hasEntityRfgField(entity)) {
        const elementKey = getElementKey(entity);
        const fnd = (globalData[IDs.ENT_CUSTOM_DATENSATZ_REIHENFOLGE] || []).find((r: any) => r.elementKey === elementKey);
        if (fnd && fnd.activated === 1) {
            return true;
        }
    }
    return false;
}

export function getFormRfgBtns(entity: string, dataItem: any, globalData: any, onRfgChange: (dataItem1: any, dataItem2: any) => void) {
    if (dataItem && dataItem.tid > 0) {
        const dataFiltered = globalData[entity].filter((r: any) => !r.parent_tid && r.jahr === dataItem.jahr && r.standort_tid_orig === dataItem.standort_tid_orig);
        const dataSorted = sortDataRfg(dataFiltered);
        const fndIdx = dataSorted.findIndex((r: any) => r.tid === dataItem.tid);
        if (fndIdx >= 0 && dataSorted.length > 0) {
            const onClick = (indicator: number) => {
                if (indicator > 0) {
                    // Nach unten verschieben
                    if (dataSorted[fndIdx + 1]) {
                        // rfg tauschen
                        const rfg1 = dataSorted[fndIdx].rfg || dataSorted[fndIdx].tid;
                        const rfg2 = dataSorted[fndIdx + 1].rfg || dataSorted[fndIdx + 1].tid;
                        dataSorted[fndIdx].rfg = rfg2;
                        dataSorted[fndIdx + 1].rfg = rfg1;
                        // _formKey tauschen
                        const _formKey1 = dataSorted[fndIdx]._formKey;
                        const _formKey2 = dataSorted[fndIdx + 1]._formKey;
                        dataSorted[fndIdx]._formKey = _formKey2;
                        dataSorted[fndIdx + 1]._formKey = _formKey1;
                        onRfgChange(dataSorted[fndIdx], dataSorted[fndIdx + 1]);
                    }
                } else if (indicator < 0) {
                    // Nach oben verschieben
                    if (dataSorted[fndIdx - 1]) {
                        // rfg tauschen
                        const rfg1 = dataSorted[fndIdx].rfg || dataSorted[fndIdx].tid;
                        const rfg2 = dataSorted[fndIdx - 1].rfg || dataSorted[fndIdx - 1].tid;
                        dataSorted[fndIdx].rfg = rfg2;
                        dataSorted[fndIdx - 1].rfg = rfg1;
                        // _formKey tauschen
                        const _formKey1 = dataSorted[fndIdx]._formKey;
                        const _formKey2 = dataSorted[fndIdx - 1]._formKey;
                        dataSorted[fndIdx]._formKey = _formKey2;
                        dataSorted[fndIdx - 1]._formKey = _formKey1;
                        onRfgChange(dataSorted[fndIdx], dataSorted[fndIdx - 1]);
                    }
                }
            };
            const isfirst = fndIdx === 0;
            const islast = fndIdx === dataSorted.length - 1;
            return (
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 2 }}>
                    <button
                        disabled={isfirst}
                        style={{
                            color: 'black', padding: '0px 10px 5px 10px',
                            ...(isfirst ? { backgroundColor: 'lightgray' } : {})
                        }}
                        title='Datensatz nach oben verschieben'
                        onClick={() => onClick(-1)}
                    >
                        {String.fromCharCode(8593)}
                    </button>
                    <button
                        disabled={islast}
                        style={{
                            color: 'black', padding: '0px 10px 5px 10px', marginLeft: 5,
                            ...(islast ? { backgroundColor: 'lightgray' } : {})
                        }}
                        title='Datensatz nach unten verschieben'
                        onClick={() => onClick(1)}
                    >
                        {String.fromCharCode(8595)}
                    </button>
                </div>
            );
        }
    }
    return null;
}

// Gibt es mindestens in einem Jahr mehr als einen Datensatz?
export function gibtEMIEJMAED(dataRows: Array<any>, jahr_von: number, jahr_bis: number, standortTid: number): boolean {
    if (Array.isArray(dataRows)) {
        for (let jahr = jahr_von; jahr <= jahr_bis; jahr++) {
            const dataF = dataRows.filter((r: any) => !r.parent_tid && r.jahr === jahr && r.standort_tid_orig === standortTid);
            if (dataF.length > 1) {
                return true;
            }
        }
    }
    return false;
}
